<template>
  <div>
    <button @click.prevent="showEmailsSend = !showEmailsSend" type="submit" class="btn btn-primary" v-if="!showEmailsSend && academic_requests.length > 0">Ver correos enviados</button>
    <button @click.prevent="showEmailsSend = !showEmailsSend" type="submit" class="btn btn-primary" v-if="showEmailsSend && academic_requests.length > 0">Ocultar correos enviados</button>
    <table class="table" v-if="showEmailsSend">
      <thead>
        <tr>
          <th scope="col">id</th>
          <th scope="col">Asunto</th>
          <th scope="col">Contenido</th>
          <th scope="col">Adjuntos</th>
          <th scope="col">Fecha de envío</th>
          <th scope="col">Fecha de reintento</th>
          <th scope="col">Respondido</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(academic_request, key) in academic_requests" class="file-listing" :key="key">
          <td>{{ academic_request.id }}</td>
          <td>{{ academic_request.subject }}</td>
          <td>{{ academic_request.content }}</td>
          <td>
            <ol>
              <li v-for="key of Object.keys(academic_request.archives)" :key="key">
                <a
                  target="_blank"
                  :href="normalizeSecureFileUrl(academic_request.archives[key].url)"
                  style="text-decoration:none; color: #3c1a4e;"
                  @click.prevent="openAcademicArchive(academic_request.archives[key])"
                >{{academic_request.archives[key].name}}</a>
              </li>
            </ol>
          </td>
          <td>{{ academic_request.request_information_date | parseDate }}</td>
          <td>{{ academic_request.retry_date | parseDate }}</td>
          <td>{{ academic_request.verified | parseBoolean }}</td>
        </tr>
      </tbody>
    </table>    
    <h1>
      Enviar correo. {{project.person_id}} {{project.first_name}} {{project.last_name}}
    </h1>
		<div :class="typeMessage" role="alert" id="message-update" v-if="message != ''">
			{{message}}
		</div>    
    <form>
      <div class="form-group" v-if="this.mail_config != null">
        <label for="exampleInputEmail1">Email: {{this.mail_config.email}}</label>
      </div>      
      <div class="form-group">
        <label for="exampleInputEmail1">Asunto</label>
        <input v-model="form.subject" type="text" class="form-control" id="subject" aria-describedby="subjecHelp">
        <small id="subjecHelp" class="form-text text-muted">Ingrese el asunto del correo</small>
      </div>
      <button @click.prevent="viewTemplate = !viewTemplate" type="submit" class="btn btn-primary" v-if="!viewTemplate">Ver plantilla</button>
      <button @click.prevent="viewTemplate = !viewTemplate" type="submit" class="btn btn-primary" v-if="viewTemplate">Ocultar plantilla</button>
      <p v-if="viewTemplate">
        Verificación académica <br>
        ¡Hola! Uno de tus egresados está en un proceso de selección y nosotros somos los encargados de verificar sus datos. ¿Podrías confirmarnos si se graduó de INSTITUCIÓN? <br>
        NOMBRE: xxxxxxxxx <br>
        CÉDULA: xxxxxxxx <br>
        PROGRAMA (o PROFESIÓN, según esté el campo): xxxxxxx <br>
        AÑO DE GRADUACIÓN: xxxxxxxxx        
      </p>
      <div class="form-group">
        <label for="exampleInputPassword1">Contenido</label>
        <textarea v-model="form.content" form.content type="text" class="form-control" id="content" aria-describedby="contentHelp" rows="10"/>
        <small id="contentHelp" class="form-text text-muted">Ingrese el contenido del mensaje</small>
      </div>
      <div class="form-group">
        <attachments :formData.sync="formData"/>
      </div>
      <div class="progress" v-if="sending">
        <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: 75%"></div>
      </div>
      <button @click.prevent="sendEmail" type="submit" class="btn btn-primary">Enviar</button>
    </form>
  </div>
</template>

<script>
import axios from 'axios';
import Attachments from './attachments.vue'
import secureFiles from '../../../../mixins/secureFiles'
export default {
  name: 'MailForm',
  mixins: [secureFiles],
  props: ['project', 'academic_requests', 'academic_reference'],
  data() {
    return {
      token: '',
      form: {},
      formData: new FormData(),
      message: '',
      typeMessage: '',
      showEmailsSend: false,
      sending: false,
      viewTemplate: false,
      mail_config: null
    }
  },
  components: {
    'attachments': Attachments,
  },
  methods: {
    setCredentials(){
      axios.defaults.headers['x-csrf-token'] = this.token
      axios.defaults.headers.common['Accept'] = 'application/json';
      axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    },    
    async sendEmail(){
      this.sending = true
      let request_mail_config = await axios.get(`/mail_config_by_academic_reference?academic_reference_id=${this.academic_reference.id}`, {}, {})
      if (request_mail_config.status == 200) {
        this.mail_config = request_mail_config.data.mail_config
        if (this.mail_config.email != null && this.form.subject != null && this.form.content != null) {
          this.setCredentials()
          let archives = []
          this.formData.append('academic_request[subject]', this.form.subject)
          this.formData.append('academic_request[content]', this.form.content)
          this.formData.append('academic_request[project_id]', this.project.id)
          this.formData.append('academic_request[academic_reference_id]', this.academic_reference.id)
          if (this.mail_config.mail_config_level == 'mail_config_elementary') {
            this.formData.append('academic_request[academic_type]', 'academic_elementary')
          }
          if (this.mail_config.mail_config_level == 'mail_config_superior') {
            this.formData.append('academic_request[academic_type]', 'academic_superior')
          }        
          let headers = { headers: { 'Content-Type': 'multipart/form-data' } }
          axios.post(`/academic_requests`, this.formData, headers).then(res=>{
            if (res.status == 201) {
              this.showMessage('Email enviado', 'alert-success')
              let academic_request = res.data.academic_request
              this.academic_requests.unshift(academic_request)
            }
            this.sending = false
          }, (err) => {
            this.showMessage('No se pudo crear la configuración', 'alert-danger')
            this.sending = false
          })
        } else {
          this.showMessage('Faltan datos para poder enviar el correo', 'alert-danger')
          this.sending = false
        }        
      }
    },
    showMessage(message, typeMessage){
      this.message = message
      this.typeMessage = `alert ${typeMessage}`
      setTimeout(() => this.message = '', 3000)
    },
    openAcademicArchive (archive) {
      const options = archive.id
        ? { resourceType: 'project_archive', id: archive.id }
        : {}
      this.openSecureFileUrl(archive.url, options)
    },
  },
  created () {
    this.token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
  },
  filters: {
    parseDate: function(value) {
      let date = new Date(value)
      let datestring = date.getDate()  + "-" + (date.getMonth()+1) + "-" + date.getFullYear() + " " + date.getHours() + ":" + date.getMinutes();
      return datestring;
    },
    parseBoolean: function(value) {
      if (value) {
        return 'Si'
      } else {
        return 'No'
      }
    }
  }  
}
</script>

<style scoped>
  .row-required-attachments{
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
</style>